import Layout from '../../features/Layout';
import Terms from '../../components/Terms';

const TermsPage = ({ isProd }: { isProd: boolean }) => {
  return (
    <Layout
      title="Khatabook - Terms and Conditions"
      description="Read the Terms and Conditions for using Khatabook. Digital India's Digital Khata!"
      isProd={isProd}
    >
      <Terms />
    </Layout>
  );
};

export default TermsPage;
